"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Initials = void 0;
var React = __importStar(require("react"));
var styles = __importStar(require("./Initials.module.css"));
var mobx_react_1 = require("mobx-react");
var moment = require("moment");
var react_1 = require("react");
var postMessage_1 = __importDefault(require("./../../../pdf/lib/functions/postMessage"));
var Initials = (function (_super) {
    __extends(Initials, _super);
    function Initials(props) {
        var _this = _super.call(this, props) || this;
        _this.json_data = props.model.json_data;
        props.model.dispatcher.addListener(function () {
            _this.json_data = props.model.json_data;
            _this.forceUpdate();
        });
        return _this;
    }
    Initials.prototype.onClick = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var _d, id, model, onChange, groupName, type, nextInputId, nextInputRef, initials, initialsGrouped, index, element;
            return __generator(this, function (_e) {
                _d = this.props, id = _d.id, model = _d.model, onChange = _d.onChange, groupName = _d.groupName, type = _d.type, nextInputId = _d.nextInputId;
                if (!((_a = model.taskUserInfo) === null || _a === void 0 ? void 0 : _a.initials)) {
                    (0, postMessage_1.default)({
                        type: "action",
                        message: "create_initials",
                        field: id
                    });
                }
                else if (nextInputId) {
                    nextInputRef = document.getElementById(nextInputId);
                    nextInputRef.focus();
                }
                if (!this.json_data[type] && ((_b = model.taskUserInfo) === null || _b === void 0 ? void 0 : _b.initials)) {
                    initials = (_c = model.taskUserInfo) === null || _c === void 0 ? void 0 : _c.initials;
                    this.json_data[type] = initials;
                    this.json_data["initials"] = initials;
                    this.json_data[id] = initials;
                    this.json_data["".concat(id, "_date")] = moment.utc().format();
                    if (groupName) {
                        initialsGrouped = document.getElementsByName(groupName);
                        for (index = 0; index < initialsGrouped.length; index++) {
                            element = initialsGrouped[index];
                            if (element.id !== id) {
                                this.json_data[element.id] = null;
                                this.json_data["".concat(element.id, "_date")] = "";
                            }
                        }
                    }
                    if (onChange) {
                        onChange(id, initials);
                    }
                }
                model.dispatcher.dispatch();
                return [2];
            });
        });
    };
    Initials.prototype.render = function () {
        var _a = this.props, id = _a.id, onChange = _a.onChange, groupName = _a.groupName, model = _a.model, _b = _a.errors, errors = _b === void 0 ? {} : _b, className = _a.className, classNameWrap = _a.classNameWrap, underline = _a.underline, title = _a.title;
        var error = errors[id];
        var src = model.json_data[this.props.type] || "#";
        var isSigned = Boolean(model.json_data[this.props.id]);
        var extraClass = "";
        if (window.isPdf) {
            extraClass = "hide";
        }
        var html = React.createElement("img", { src: src, width: "150", height: "75" });
        if (!isSigned && !className.includes("disabled-user-field")) {
            html = (React.createElement("button", { id: "".concat(id, "_btn"), onClick: this.onClick.bind(this), className: "".concat(styles.button, " ").concat(extraClass) }, "Click"));
        }
        var date = "";
        if (isSigned) {
            date = moment(this.json_data["".concat(id, "_date")]).format("MM/DD/YYYY");
        }
        return (React.createElement("div", { className: classNameWrap },
            React.createElement("div", { className: "".concat(styles.root) },
                React.createElement("div", { className: underline ? "".concat(styles.underline) : "" },
                    React.createElement("div", __assign({ id: id, className: "".concat(styles.box, " ").concat(className), tabIndex: 0 }, { name: groupName }), html)),
                error && React.createElement("p", { className: styles.error },
                    error,
                    " "),
                underline && React.createElement("em", null,
                    " Intial ",
                    title,
                    " "))));
    };
    Initials.defaultProps = {
        type: "initial"
    };
    Initials = __decorate([
        mobx_react_1.observer
    ], Initials);
    return Initials;
}(react_1.Component));
exports.Initials = Initials;
//# sourceMappingURL=data:application/json;base64,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